import React from 'react';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import { makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    fontSize: 36,
    color: theme.palette.auxiliary.green.light,
  },
  pointsText: {
    fontSize: 14,
    color: theme.palette.neutrals.low.light,
    fontWeight: 600,
    textAlign: 'right',
  },
  pointsNumber: {
    fontSize: 31.25,
    color: theme.palette.neutrals.low.main,
    fontWeight: 'bold',
  },
}));

function WalletPoints({ points }) {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.header}>
      <div>
        <AccountBalanceWalletIcon className={classes.icon} />
      </div>
      <div style={{ marginLeft: 130 }}>
        <div className={classes.pointsText}>{t('pontos').toLowerCase()}</div>
        <div className={classes.pointsNumber}>
          {points?.points?.amount?.toFixed(2) || 0}
        </div>
      </div>
    </div>
  );
}

export { WalletPoints };
